import http from '@/http';

export default class LocalProvaService {

	createOrUpdate(localProva, flagAlterar) {
		if(flagAlterar){
			console.log('update ... LocalProva');
			return http.put(`local-prova/${localProva.get('id')}`, localProva)
				.then(res => {res.data});

		}else{
			console.log('create ... LocalProva');
			return http.post('local-prova', localProva)
				.then(res => res.data);
		}
    }

	removerLocalProva(localProvaId) {
		return http.delete(`local-prova/${localProvaId}`).then(res => res.data);
	}

	getLocalProvaById(localProvaId) {
		return http.get(`local-prova/${localProvaId}`).then(res => res.data);
    }

	getListaLocalProvaBySelecao(selecaoId) {
		return http.get(`local-prova/lista/${selecaoId}`).then(res => res.data);
    }

	getListaAreaPendenteLocalDeProva(selecaoId) {
		return http.get(`local-prova/areasPendentes/${selecaoId}`).then(res => res.data);
    }

	getQuantidadeSalasIndividuaisPorArea(selecaoId, selecaoAreaIds) {
		let param = {'selecaoId': selecaoId, 'selecaoAreaIds': selecaoAreaIds};
		return http.post(`local-prova/areaSalasIndividuais`, param).then(res => res.data);
    }

	getDownloadModelo() {
		var url = `local-prova/downloadModelo`

		http({url: url, method: 'GET',responseType:'blob'}).then(reponse => {
			const fileBlob = new Blob([reponse.data])
			const fileUrl = window.URL.createObjectURL(fileBlob)

			const fileLink = document.createElement('a')
			fileLink.href = fileUrl

			let tituloArquivo = 'estrutura_escola_modelo.xlsx';
			fileLink.setAttribute('download', tituloArquivo);
			document.body.appendChild(fileLink)

			fileLink.click()
		})
	}

}
